import { useEffect } from 'react';
import HeroSectionFr from './components/HeroSectionFr';
import AboutSectionFr from './components/AboutSectionFr';
import IndustriesSectionFr from './components/IndustriesSectionFr';
import ServicesSectionFr from './components/ServicesSectionFr';
import DeRiskingSectionFr from './components/DeRiskingSectionFr';
import NewsAndSupplierSectionFr from './components/NewsAndSupplierSectionFr';
import CTASectionFr from './components/CTASectionFr';

const HOME_SCHEMA_FR = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      name: 'MAX-Sourcing',
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      logo: {
        '@type': 'ImageObject',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/logo.png`,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-819-923-0918',
        contactType: 'service client',
        email: 'contact@MAX-Sourcing.com',
        areaServed: ['US', 'CA', 'GB', 'CN', 'IN'],
        availableLanguage: ['French', 'English'],
      },
      description:
        'MAX-Sourcing delivers global sourcing of fine chemicals, APIs, and compliant supply chain solutions. Serving clients across US, Europe, Canada, China and India.',
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr#webpage`,
      url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr`,
      name: 'MAX-Sourcing | Approvisionnement Pharmaceutique Mondial & Produits Chimiques Fins',
      description:
        'MAX-Sourcing offre un approvisionnement mondial en produits chimiques fins, IPA pharmaceutiques et solutions de chaîne d\'approvisionnement conformes aux BPF. Au service des clients aux États-Unis, en Europe, au Canada, en Chine et en Inde.',
      inLanguage: 'fr',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization` },
      dateModified: '2026-04-07',
      translationOfWork: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#webpage`,
        url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
        inLanguage: 'en',
      },
      workTranslation: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#webpage`,
        url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
        inLanguage: 'en',
      },
    },
  ],
};

export default function HomePageFr() {
  useEffect(() => {
    document.title = 'MAX-Sourcing | Approvisionnement Pharmaceutique Mondial & Produits Chimiques Fins';
    const id = 'schema-home-fr';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(HOME_SCHEMA_FR);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <main>
      <HeroSectionFr />
      <AboutSectionFr />
      <IndustriesSectionFr />
      <ServicesSectionFr />
      <DeRiskingSectionFr />
      <NewsAndSupplierSectionFr />
      <CTASectionFr />
    </main>
  );
}
